import script from "./ConfigurationModalSelectTrigger.vue?vue&type=script&setup=true&lang=js"
export * from "./ConfigurationModalSelectTrigger.vue?vue&type=script&setup=true&lang=js"

import "./ConfigurationModalSelectTrigger.vue?vue&type=style&index=0&id=e891115a&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e891115a"]])

export default __exports__